/**
 * WORK_SCHEDULES
 *
 * Enumeração das escalas de trabalho baseadas em jornadas por horas contínuas.
 *
 * Escalas incluídas:
 *
 * 1 - 12x36 → Trabalha 12h, descansa 36h.
 * 2 - 24x48 → Trabalha 24h, descansa 48h.
 * 3 - 12x60 → Trabalha 12h, descansa 60h.
 * 4 - 18x36 → Trabalha 18h, descansa 36h.
 * 5 - 24x72 → Trabalha 24h, descansa 72h.
 */
export const WORK_SCHEDULES = {
  '12x36': 1,
  '24x48': 2

  // Para habilitar essas escalas é necessário avaliar os impactos
  // '12x60': 3,
  // '18x36': 4,
  // '24x72': 5
};
